export default async function sequentialRequests(promises: (() => Promise<unknown>)[]) {
  const results: unknown[] = [];
  await promises.reduce((prevPromise, currentPromise) => prevPromise
      .then(currentPromise)
      .then(res => {
        results.push(res);
      }),
    Promise.resolve()
  );
  return results;
}
